import { render } from "./VideoSubtitle.vue?vue&type=template&id=5e06f182&scoped=true"
import script from "./VideoSubtitle.vue?vue&type=script&lang=js"
export * from "./VideoSubtitle.vue?vue&type=script&lang=js"

import "./VideoSubtitle.vue?vue&type=style&index=0&id=5e06f182&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-5e06f182"

export default script